import { render, staticRenderFns } from "./AromaBindGuide.vue?vue&type=template&id=86c2f87e&scoped=true"
import script from "./AromaBindGuide.vue?vue&type=script&lang=js"
export * from "./AromaBindGuide.vue?vue&type=script&lang=js"
import style0 from "./AromaBindGuide.vue?vue&type=style&index=0&id=86c2f87e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c2f87e",
  null
  
)

export default component.exports